//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogAuth from "@/views/Setting/AccountManagement/components/DialogAuth";
export default {
  name: "AccontList",
  props: {},
  data() {
    return {
      accountList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      masterId: "",
      curAccount: {},
      dialogAuthVisible: false,
      ownAuthData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      backPath: "",
    };
  },
  components: { DialogAuth },
  created() {},
  methods: {
    close(type) {
      this[type] = false;
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-07 14:42:19
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCooAccountList();
    },
    /**
     * @description: 账号查询
     * @Author: yangsibo
     * @Date: 2022-06-21 09:58:34
     */
    async getCooAccountList() {
      let urlField =
        this.backPath == "/village/management/list" ? "village" : "coo";
      let { data } = await this.$http.basicInfo.getCooAccountList(urlField, {
        ...this.pagination,
        masterId: this.masterId,
      });
      this.pagination.recordTotal = data.recordTotal;
      this.accountList = data.content;
    },
    /**
     * @description: 查看详情
     * @Author: yangsibo
     * @Date: 2022-06-06 14:50:28
     * @param {*} id 角色id
     */
    toDetail(item) {
      item.roleIdList = item.roleIdList ? item.roleIdList : [];
      this.curAccount = item;
      this.dialogAuthVisible = true;
      this.ownAuthData = [];
      let { roleIdList } = item;
      if (roleIdList && roleIdList.length > 0) {
        roleIdList.forEach((item, index) => {
          this.getSelectOwnMenuTree({ roleIdList: [item], index });
        });
      }
    },
    /**
     * @descripttion: 获取某角色的权限
     * @Author: juanjuanhui
     * @Date: 2022-02-22 19:54:22
     * @param {*}
     */
    async getSelectOwnMenuTree(params) {
      let { roleIdList, index } = params;
      let arr = this.curAccount.roleNames.split(",");
      try {
        let { data } = await this.$http.common.selectOwnSMenuTree({
          roleIdList,
        });
        this.ownAuthData.push({
          roleName: arr[index],
          authData: data,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    let { $businessAccountId, $backPath } = this.$route.query;
    this.masterId = $businessAccountId;
    this.backPath = $backPath;
    this.getCooAccountList();
  },
};
